/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Объект с данными продукта
 * @export
 * @interface GetProductsAsGroupName200ResponseDataInnerData
 */
export interface GetProductsAsGroupName200ResponseDataInnerData {
  /**
   * HTML-описание продукта
   * @type {string}
   * @memberof GetProductsAsGroupName200ResponseDataInnerData
   */
  productDescription?: string | null
}

/**
 * Check if a given object implements the GetProductsAsGroupName200ResponseDataInnerData interface.
 */
export function instanceOfGetProductsAsGroupName200ResponseDataInnerData(
  value: object
): value is GetProductsAsGroupName200ResponseDataInnerData {
  return true
}

export function GetProductsAsGroupName200ResponseDataInnerDataFromJSON(
  json: any
): GetProductsAsGroupName200ResponseDataInnerData {
  return GetProductsAsGroupName200ResponseDataInnerDataFromJSONTyped(
    json,
    false
  )
}

export function GetProductsAsGroupName200ResponseDataInnerDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetProductsAsGroupName200ResponseDataInnerData {
  if (json == null) {
    return json
  }
  return {
    productDescription:
      json['productDescription'] == null
        ? undefined
        : json['productDescription'],
  }
}

export function GetProductsAsGroupName200ResponseDataInnerDataToJSON(
  value?: GetProductsAsGroupName200ResponseDataInnerData | null
): any {
  if (value == null) {
    return value
  }
  return {
    productDescription: value['productDescription'],
  }
}
